// src/components/ProtectedRoute.jsx
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({
  children,
  allowedRoles = [],
  redirectPath = '/login',
  unauthorizedPath = '/access-denied',
}) => {
  const { isAuthenticated, hasAnyRole, loading, user } = useAuth();
  const location = useLocation();

  console.log('🔒 ProtectedRoute check:', { 
    isAuthenticated, 
    loading, 
    hasUser: !!user,
    userRole: user?.role,
    path: location.pathname,
    allowedRoles 
  });

  if (loading) {
    console.log('⏳ Still loading...');
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('❌ Not authenticated, redirecting to:', redirectPath);
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  if (allowedRoles.length > 0 && !hasAnyRole(allowedRoles)) {
    console.log('❌ Role not allowed, redirecting to:', unauthorizedPath);
    return <Navigate to={unauthorizedPath} replace />;
  }

  console.log('✅ Access granted');
  return children;
};

export default ProtectedRoute;